<template lang="pug">
.page
  .search
    RomatchInput.search-input(label="Zoek" v-model="searchTerm")
    RomatchAdminButton(@click="$router.push('/vacancies/new')") Vacature toevoegen
  transition(name="fade" mode="out-in")
    div(v-if="loading") loading...
    div(v-else)
      .vacancies(v-if="vacanciesAreLoaded")
        div(v-for="vacancy in filteredVacancies")
          VacancyCard(:vacancy="vacancy")
        div(v-show="filteredVacancies.length === 0") Er zijn geen vacatures gevonden met de zoekterm "{{searchTerm}}"
      p(v-else) Op dit moment zijn er geen vacatures beschikbaar
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import VacancyCard from '@/components/VacancyCard.vue'

export default {
  name: 'Vacancies',
  components: { VacancyCard },
  data() {
    return {
      searchTerm: '',
      loading: true,
    }
  },
  computed: {
    ...mapState('vacancies', ['vacancies']),
    ...mapGetters('vacancies', ['vacanciesAreLoaded', 'filterVacancies']),
    ...mapGetters('auth', ['loggedIn']),
    filteredVacancies() {
      return this.filterVacancies(this.searchTerm)
    },
    reactionCount(vacancy) {
      return vacancy.reactions.items.length
    },
  },
  methods: mapActions('vacancies', ['maybeFetchVacancies']),
  mounted() {
    this.loading = true
    this.maybeFetchVacancies().then(() => (this.loading = false))
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

.page
  max-width romatch-max-width
  margin auto

.vacancies
  display grid
  grid-template-columns 1fr
  grid-gap 2rem
  margin auto
  text-align left

  @media only screen and (min-width: small)
    grid-template-columns 1fr 1fr

// filters
.search
  display flex
  flex-wrap wrap
  justify-content space-between
  margin 0 auto
  margin-bottom 3rem
  padding 0

  button
    margin-top 1rem

.search-input
  max-width 400px
</style>
